/*
 * @Author: Mufaddal Jamali
 * @Date: 2020-02-24 15:49:21
 * @Last Modified by: Mufaddal Jamali
 * @Last Modified time: 2021-01-28 13:52:04
 */

import React, { Component } from "react";
import { DataService } from "../services/data.service";
import { Select } from "antd";

import $ from "jquery";

import { Empty } from "antd";
import Loader from "../components/loader/loader";
import * as handler from "../components/utils/handler";

import dummyData from "../data/deviceDetails.json";
const queryString = require("query-string");

const { Option } = Select;

class DeviceService extends Component {
  model = undefined;
  color = null;
  selectedProductType = null;
  selectedProductFamily = null;
  imei = null;
  service = new DataService();
  state = {
    phoneModels: [],
    phoneColors: [],
    productTypes: [],
    productFamily: [],

    selectedModel: undefined,

    dataLoaded: false,
    lang: {},
    categorybtn: false,
    categories: [],
    premiumCategories: [],
    dataLoaded: false,
    singleBranchDetails: [],
    phoneServices: [],
    symptomDetails: [],
    selectedCategory: null,
    selectedService: null,
    selectedSymptomDetail: null,
    dataLoaded: false,
    serverResponded: true,
    imei: null,
    isValidImei: undefined,
    lang: {},
    imeidrowpdown: false,
  };

  imeiRef = React.createRef();
  isValidIemiSerielNumber = false;
  categoryId = null;
  deviceHealth = null;
  phoneServiceName = null;
  symptomDetailName = null;
  imei = null;
  isRepairServiceSelected = false;

  defaultCategory = window["app-config"].defaultCategory;
  defaultServices = window["app-config"].defaultServices;
  defaultLanguage = window["app-config"].defaultLang;
  isMandatoryImei = window["app-config"].isMandatoryImei;

  //allSymptomDetails=window["app-config"].SymptomDetails;
  allSymptomDetails = [];

  collections = window["app-config"].collections;
  premiumAppointments = window["app-config"].premiumAppointments;
  URL = window["app-config"].URL;
  choosecategroyvalue =
    window["app-config"].applicationProperties.choosecategroyvalue;
  defaultLanguage = window["app-config"].defaultLang;
  URL = window["app-config"].URL;
  queryStringBranchCode = queryString.parse(window.location.search);
  branchCode = this.queryStringBranchCode.branchCode;
  premiumAppointments = window["app-config"].premiumAppointments;
  async componentDidMount() {
    this.getDeviceDetails();
    this.setState({ lang: handler.setTranslations() });
    this.getData();
    this.props.setHeading(null);
    this.props.hideBtnNext();
    this.setState({ lang: handler.setTranslations() });
    this.props.hideBtnNext();
    this.props.setHeading(null);
    // this.getUpdatedDeviceDetails();
    $(".validate-text").on("keypress", function (event) {
      var regex = new RegExp("^[a-zA-Z0-9]+$");
      var key = String.fromCharCode(
        !event.charCode ? event.which : event.charCode
      );
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    });
    setInterval(() => {
      if (
        this.state.selectedService !== null &&
        this.state.imeidrowpdown == true &&
        this.state.imei == null &&
        this.isMandatoryImei !== false
      ) {
        this.props.hideBtnNext();
      }
    }, 10);
  }

  getDeviceDetails = async () => {
    try {
      let response = await this.service.getDeviceDetails();

      if (response.data.error !== undefined && response.data.error === true) {
        this.setState({
          productTypes: undefined,
          dataLoaded: true,
        });
      } else {
        let productTypes = response.data.productsInfo.productTypes;
        this.setState({
          productTypes: productTypes === "" ? [] : productTypes,
          dataLoaded: true,
        });
      }
    } catch (error) {
      if (error.message.includes("timeout")) {
        this.setState({
          productTypes: undefined,
          phoneColors: [],
          productFamily: [],
          phoneModels: [],
          dataLoaded: true,
        });
      } else {
        this.setState({
          productTypes: [],
          productFamily: [],
          phoneModels: [],
          phoneColors: [],
          dataLoaded: true,
        });
      }
    }
  };

  getUpdatedDeviceDetails = () => {
    this.setState({ productTypes: dummyData.productTypes });
  };

  onModelSearch = (val) => {
    console.log("search:", val);
  };

  _onProductTypeChange = (e) => {
    debugger;

    this.selectedProductType = e.target.value;
    this.sendDataToParentdevice();

    $("#family-selector").val("-1");
    $("#color-selector").val("-1");
    $("#model-selector").val("-1");
    $("#category-selector-sam").val("-1");
    this.props.hideBtnNext();

    let family = this.state.productTypes.filter(
      (f) => f.ProductName === e.target.value
    );

    this.setState({
      productFamily: family[0].ProductFamily,
      phoneModels: [],
      selectedModel: undefined,
    });
  };

  _onProductFamilyChange = (e) => {
    debugger;
    this.selectedProductFamily = e.target.value;
    this.sendDataToParentdevice();

    $("#model-selector").val("-1");
    $("#color-selector").val("-1");
    $("#category-selector-sam").val("-1");

    let models = this.state.productFamily.filter(
      (f) => f.FamilyName === e.target.value
    );

    this.setState({
      phoneModels: models[0].phoneModels,
      selectedModel: undefined,
    });
  };
  _onModelChange = (e) => {
    debugger;
    this.setState({ selectedModel: e.target.value });
    this.sendDataToParentdevice();

    $("#category-selector-sam").val("-1");
  };

  _onModelSearch = (val) => {
    console.log("search:", val);
  };

  _onColorChange = (e) => {
    this.color = e.target.value;

    this.sendDataToParent();
  };

  sendDataToParentdevice = () => {
    this.props.deviceDetails({
      model: this.state.selectedModel,
      color: this.color,
      productType: this.selectedProductType,
      productFamily: this.selectedProductFamily,
    });
  };

  getData = async () => {
    try {
      var branchId = await (
        await this.service.getSingleBranchDetails()
      ).data.branchList[0].BranchID;

      let categoryListResp = await this.service.getCategoriesByBranchId(
        branchId
      );

      let filteredCategories = handler.compareArrayOfObject(
        categoryListResp.data.categoryList,
        this.collections.categories
      );
      let filteredPremiumCategories = handler.compareArrayOfObject(
        categoryListResp.data.categoryList,
        this.premiumAppointments.premiumCategories
      );
      console.log(filteredPremiumCategories);

      if (
        categoryListResp.data.error !== undefined &&
        categoryListResp.data.error === true
      ) {
        this.setState({
          categories: [],
          premiumCategories: [],
          dataLoaded: true,
          phoneServices: [],
          serverResponded: false,
        });
      } else {
        let categoryList = categoryListResp.data.categoryList;

        this.setState({
          categories:
            filteredCategories.length > 0 ? filteredCategories : categoryList,
          dataLoaded: true,
          premiumCategories:
            filteredPremiumCategories.length > 0
              ? filteredPremiumCategories
              : categoryList,
          // singleBranchDetails: branchID,
        });
      }
    } catch (error) {
      console.log("ERROR", error.message);
      this.setState({
        categories: [],
        premiumCategories: [],
        phoneServices: [],
        dataLoaded: true,
        singleBranchDetails: [],
        serverResponded: error.message.includes("timeout") ? false : true,
      });
    }
  };

  onCategoryChange = (e) => {
    this.props.showBtnNext();
    this.categoryId = e.target.value;
    console.log("this.categoryId:", this.categoryId);
    this.setState({ selectedCategory: e.target.value });

    if (e.target.value !== this.defaultCategory) {
      this.phoneServiceName = null;
      this.imei = null;
      this.symptomDetailName = null;
      this.setState({
        selectedService: null,
        imei: null,
        selectedSymptomDetail: null,
      });
    }

    this.sendDataToParent();
  };

  onDeviceHealthChange = (e) => {
    if (this.state.isValidImei === false) {
      console.log("IN IF DH");
      this.props.hideBtnNext();
    } else if (
      this.defaultServices.includes(this.state.selectedService) &&
      this.state.imei === null &&
      this.isMandatoryImei === true &&
      this.state.isValidImei === undefined
    ) {
      console.log("IN ELSEIF DH");
      this.props.hideBtnNext();
    } else {
      console.log("IN ELSE DH");
      this.deviceHealth = e.target.value;
      this.sendDataToParent();
    }
  };

  onPhoneServiceChange = (e) => {
    this.props.showBtnNext();
    this.phoneServiceName = e.target.value;
    console.log("this.phoneServiceName  :", this.phoneServiceName);
    this.setState({ selectedService: e.target.value });
    console.log(this.allSymptomDetails);
    this.state.symptomDetails = [];
    this.symptomDetailName = null;
    this.setState({ selectedSymptomDetail: null });

    for (let symptom in this.state.phoneServices) {
      if (
        this.state.phoneServices[symptom].ServiceName.toLowerCase() ==
        this.phoneServiceName.toLowerCase()
      ) {
        this.state.symptomDetails =
          this.state.phoneServices[symptom].SymptomDetail;
        break;
      }
    }

    if (this.state.symptomDetails == null) {
      this.state.symptomDetails = [];
      this.symptomDetailName = null;
      this.setState({ selectedSymptomDetail: null });
    }

    setTimeout(() => {
      this.sendDataToParent();
    }, 200);

    if (
      this.defaultServices.includes(e.target.value) &&
      this.state.imei === null &&
      (this.state.isValidImei === false || this.state.isValidImei === undefined)
    ) {
      this.props.hideBtnNext();
      this.setState({ imeidrowpdown: true });
    } else if (
      !this.defaultServices.includes(e.target.value) &&
      this.state.isValidImei === false &&
      this.state.imei !== ""
    ) {
      this.setState({ imeidrowpdown: false });
      this.props.hideBtnNext();
    } else if (this.state.imei !== null && this.state.isValidImei === false) {
      this.setState({ imeidrowpdown: false });
      this.props.hideBtnNext();
    } else if (this.symptomDetailName == null) {
      this.setState({ imeidrowpdown: false });
      this.props.hideBtnNext();
    } else {
      this.setState({ imeidrowpdown: false });
      this.props.showBtnNext();
    }
  };

  onSymptomDetailChange = (e) => {
    this.symptomDetailName = e.target.value;
    this.setState({ selectedSymptomDetail: e.target.value });
    setTimeout(() => {
      this.sendDataToParent();
    }, 200);
  };

  sendDataToParent = () => {
    this.props.serviceDetails({
      categoryId: this.categoryId,
      deviceHealth: this.deviceHealth,
      phoneServiceName:
        this.categoryId === this.defaultCategory &&
        this.phoneServiceName === null
          ? undefined
          : this.phoneServiceName,
      symptomDetailName:
        this.categoryId === this.defaultCategory &&
        (this.symptomDetailName == null || this.symptomDetailName == undefined)
          ? ""
          : this.state.selectedSymptomDetail,
      //symptomDetailName:this.phoneServiceName==this.defaultCategory?this.symptomDetailName:null,
      imei: this.state.imei,
    });

    console.log(this.state.selectedSymptomDetail);
  };
  render() {
    if (this.state.dataLoaded === false) {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <h2>{this.state.lang.TellUsSomethingElse}</h2>

            <div className="sl__modal--row"></div>
          </div>
        </div>
      );
    } else if (!this.state.serverResponded) {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <div className="sl__modal--row">
              <Empty description={this.state.lang.ServerNotResponding} />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <h2>{this.state.lang.TellUsSomethingElse}</h2>
            <div className="sl__modal_form-row">
              <div className="sl__modal_form-col">
                <label className="sl__modal_form--label">
                  {this.state.lang.ProductTypeLabel}
                  <span className="estaric">*</span>
                </label>
                <select
                  id="product-type-selector"
                  onChange={this._onProductTypeChange}
                  className="sl__modal_form--select"
                  defaultValue={-1}
                >
                  <option disabled value={-1}>
                    {this.state.lang.ProductTypePlaceholder}
                  </option>

                  {this.state.productTypes !== null &&
                  this.state.productTypes.length > 0
                    ? this.state.productTypes.map((data, i) => {
                        return (
                          <option value={data.ProductName} key={i}>
                            {data.ProductName}
                          </option>
                        );
                      })
                    : null}
                </select>
              </div>

              <div className="sl__modal_form-col">
                <label className="sl__modal_form--label">
                  {this.state.lang.ProductFamilyLabel}
                  <span className="estaric">*</span>
                </label>
                <select
                  id="family-selector"
                  onChange={this._onProductFamilyChange}
                  className="sl__modal_form--select"
                  defaultValue={-1}
                >
                  <option disabled value={-1}>
                    {this.state.lang.ProductFamilyPlaceholder}
                  </option>

                  {this.state.productFamily.length > 0
                    ? this.state.productFamily.map((data, i) => {
                        return (
                          <option value={data.FamilyName} key={i}>
                            {data.FamilyName}
                          </option>
                        );
                      })
                    : null}
                </select>
              </div>
            </div>
            <div className="sl__modal_form-row">
              {/* <div className="sl__modal_form-col">
                <label className="sl__modal_form--label">
                  {this.state.lang.WhenDidYouBuyIt}
                  <span className="estaric">*</span>
                </label>
                <select
                  id="devicehealth-selector"
                  className="sl__modal_form--select"
                  defaultValue={-1}
                  onChange={this.onDeviceHealthChange}
                >
                  <option value={-1} disabled>
                    {this.state.lang.ChooseYourPurchaseDate}
                  </option>
                  <option value={this.state.lang.LessThanTwoYears}>
                    {this.state.lang.LessThanTwoYears}
                  </option>
                  <option value={this.state.lang.OverYearsAgo}>
                    {this.state.lang.OverYearsAgo}
                  </option>
                </select>
              </div> */}
              {this.premiumAppointments?.branchCodes.includes(
                this.branchCode
              ) ? (
                <div className="sl__modal_form-col">
                  <label className="sl__modal_form--label">
                    {this.state.lang.WhichDeviceDoYouHave}
                    <span className="estaric">*</span>
                  </label>
                  <select
                    // id="category-selector-sam"
                    className="sl__modal_form--select"
                    defaultValue={-1}
                    // showSearch
                    // style={{ width: 200 }}
                    placeholder={this.state.lang.ChooseYourModel}
                    // optionFilterProp="children"
                    // onChange={this._onModelChange}
                    // onSearch={this._onModelSearch}
                    // className="antSelect"
                    id="model-selector"
                    value={this.state.selectedModel}
                    onChange={this._onModelChange}
                    style={{
                      backgroundColor:
                        this.state.phoneModels?.length === 0 ||
                        this.premiumAppointments?.premiumDevices.filter(
                          (element) => {
                            return (
                              element.productFamily ===
                              this.selectedProductFamily
                            );
                          }
                        ).length === 0
                          ? "#e7e7e7"
                          : null,
                      color:
                        this.state.phoneModels?.length === 0 ||
                        this.premiumAppointments?.premiumDevices.filter(
                          (element) => {
                            return (
                              element.productFamily ===
                              this.selectedProductFamily
                            );
                          }
                        ).length === 0
                          ? "gray"
                          : null,
                    }}
                    disabled={
                      this.state.phoneModels?.length === 0 ||
                      this.premiumAppointments?.premiumDevices.filter(
                        (element) => {
                          return (
                            element.productFamily === this.selectedProductFamily
                          );
                        }
                      ).length === 0
                        ? true
                        : false
                    }
                  >
                    <option disabled value={-1}>
                      {this.state.lang.ChooseYourModel}
                    </option>
                    {this.state.phoneModels !== null
                      ? this.state.phoneModels.map((data, i) => {
                          return (
                            <option value={data.ModelName} key={i}>
                              {data.ModelName}
                            </option>
                          );
                        })
                      : null}
                  </select>
                </div>
              ) : null}
              <div className="sl__modal_form-col">
                <label className="sl__modal_form--label">
                  {this.state.lang.WhatIsCategory}
                  <span className="estaric">*</span>
                </label>
                <select
                  id="category-selector-sam"
                  className="sl__modal_form--select"
                  defaultValue={-1}
                  onChange={this.onCategoryChange}
                  style={{
                    backgroundColor:
                      this.state.phoneModels?.length === 0 ||
                      (this.premiumAppointments.branchCodes.includes(
                        this.branchCode
                      ) &&
                        (this.premiumAppointments?.premiumDevices.filter(
                          (element) => {
                            return (
                              element.productFamily ===
                              this.selectedProductFamily
                            );
                          }
                        ).length !== 0
                          ? this.state.selectedModel === undefined ||
                            this.state.selectedModel === -1
                          : false))
                        ? "#e7e7e7"
                        : null,
                    color:
                      this.state.phoneModels?.length === 0 ||
                      (this.premiumAppointments.branchCodes.includes(
                        this.branchCode
                      ) &&
                        (this.premiumAppointments?.premiumDevices.filter(
                          (element) => {
                            return (
                              element.productFamily ===
                              this.selectedProductFamily
                            );
                          }
                        ).length !== 0
                          ? this.state.selectedModel === undefined ||
                            this.state.selectedModel === -1
                          : false))
                        ? "gray"
                        : null,
                  }}
                  disabled={
                    this.state.phoneModels?.length === 0 ||
                    (this.premiumAppointments.branchCodes.includes(
                      this.branchCode
                    ) &&
                    (this.premiumAppointments?.premiumDevices.filter(
                      (element) => {
                        return (
                          element.productFamily === this.selectedProductFamily
                        );
                      }
                    ).length !== 0
                      ? this.state.selectedModel === undefined ||
                        this.state.selectedModel === -1
                      : false)
                      ? true
                      : false)
                  }
                >
                  <option disabled value={-1}>
                    {this.state.lang.ChooseYourCategory}
                  </option>
                  {this.premiumAppointments?.premiumDevices?.filter(
                    (element) => {
                      return (
                        element.productFamily === this.selectedProductFamily &&
                        element.modelNames?.includes(this.state.selectedModel)
                      );
                    }
                  ).length > 0
                    ? this.state.premiumCategories.length > 0
                      ? this.state.premiumCategories.map((data, i) => {
                          return (
                            <option value={data.CategoryID} key={i}>
                              {data.CategoryTitle}
                            </option>
                          );
                        })
                      : null
                    : this.state.categories.length > 0
                    ? this.state.categories.map((data, i) => {
                        return (
                          <option value={data.CategoryID} key={i}>
                            {data.CategoryTitle}
                          </option>
                        );
                      })
                    : null}
                </select>
              </div>
            </div>

            {/* {this.state.selectedCategory === this.defaultCategory ? (
              <div className="sl__modal_form-row">
                <div className="sl__modal_form-col">
                  <label className="sl__modal_form--label">
                    {this.state.lang.SelectSymptom}
                    <span className="estaric">*</span>
                  </label>
                  <select
                    id="service-selector"
                    className="sl__modal_form--select"
                    defaultValue={-1}
                    onChange={this.onPhoneServiceChange}
                  >
                    <option disabled value={-1}>
                      {this.state.lang.ChooseYourSymptom}
                    </option>

                    {this.state.phoneServices.length > 0
                      ? this.state.phoneServices.map((data, i) => {
                          return (
                            <option value={data.ServiceName} key={i}>
                              {data.ServiceName}
                            </option>
                          );
                        })
                      : null}
                  </select>
                </div>
              </div>
            ) : null} */}

            {/* {this.state.selectedService !== null && this.choosecategroyvalue !== false ? (
              <div className="sl__modal_form-row">
                <div className="sl__modal_form-col">
                  <label className="sl__modal_form--label">
                    {this.state.lang.SelectDetailedSymptom}
                    <span className="estaric">*</span>
                  </label>
                  <select
                    id="service-selector"
                    className="sl__modal_form--select"
                    defaultValue={-1}
                    onChange={this.onSymptomDetailChange}
                  >
                    <option disabled value={-1}>
                      {this.state.lang.ChooseSymptomDetail}
                    </option>

                    {this.state.symptomDetails.length > 0
                      ? this.state.symptomDetails.map((data, i) => {
                          return (
                            <option value={data.SymptomName} key={i}>
                              {data.SymptomName}
                            </option>
                          );
                        })
                      : null}
                  </select>
                </div>
              </div>
            ) : null}    */}

            {/* {this.state.selectedService !== null && this.state.imeidrowpdown == true ? (
              <div className="sl__modal_form-row">
                <div className="sl__modal_form-col wide">
                  <div className="imei-helper">
                    <span className="glyphicon glyphicon-info-sign info-ic"></span>
                    &nbsp;
                    <a
                      className="imei-link"
                      href={`${this.URL.imeiUrl}`}
                      target="_blank"
                    >
                      {this.state.lang.retrieveIMEI}
                    </a>
                  </div>
                  <label className="sl__modal_form--label">
                    {this.state.lang.DeviceIMEINumber}
                    {this.isMandatoryImei == true && <span className="estaric">*</span> }
                    
                  </label>
                  <input
                    data-required="true"
                    type="text"
                    maxLength={15}
                    ref={this.imeiRef}
                    name="imei"
                    placeholder={this.state.lang.IMEIOrSerialNumber}
                    id="imei-field"
                    className="sl__modal_form--input validate-text"
                    onChange={this.onImeiChange}
                  />
                </div>
              </div>
            ) : null} */}

            {/* <div className="sl__modal_form-info">
              <p>{this.state.lang.DeviceParagraph}</p>
            </div> */}
          </div>
        </div>
      );
    }

    if (this.state.productTypes === undefined) {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <div className="sl__modal--row">
              <Empty description={this.state.lang.ServerNotResponding} />
            </div>
          </div>
        </div>
      );
    } else if (this.state.dataLoaded === false) {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <h2>{this.state.lang.TellDeviceDetailsHeading}</h2>
            <Loader />
          </div>
        </div>
      );
    } else {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <h2>{this.state.lang.TellDeviceDetailsHeading}</h2>

            <div className="sl__modal_form-row">
              <div className="sl__modal_form-col">
                <label className="sl__modal_form--label">
                  {this.state.lang.WhichDeviceDoYouHave}
                  <span className="estaric">*</span>
                </label>

                <Select
                  showSearch
                  style={{ width: 200 }}
                  placeholder={this.state.lang.ChooseYourModel}
                  optionFilterProp="children"
                  onChange={this._onModelChange}
                  onSearch={this._onModelSearch}
                  className="antSelect"
                  id="model-selector"
                  value={this.state.selectedModel}
                >
                  {this.state.phoneModels !== null
                    ? this.state.phoneModels.map((data, i) => {
                        return (
                          <Option value={data.ModelName} key={i}>
                            {data.ModelName}
                          </Option>
                        );
                      })
                    : null}
                </Select>
              </div>
              <div className="sl__modal_form-col">
                <label className="sl__modal_form--label">
                  {this.state.lang.WhatIsTheColourOfYourDevice}
                  <span className="estaric">*</span>
                </label>
                <select
                  id="color-selector"
                  onChange={this._onColorChange}
                  className="sl__modal_form--select"
                  defaultValue={-1}
                >
                  <option disabled value={-1}>
                    {this.state.lang.ChooseYourColor}
                  </option>

                  {this.state.phoneColors.length > 0 &&
                  this.state.selectedModel !== undefined
                    ? this.state.phoneColors.map((data, i) => {
                        return (
                          <option value={data.ColorName} key={i}>
                            {data.ColorName}
                          </option>
                        );
                      })
                    : null}
                </select>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default DeviceService;
